import { createStructuredSelector } from 'reselect';
import { dragHotspotGroupLayoutId, dragHotspotPosition, moveableLayoutId } from 'containers/App/selectors';
import { documents } from 'containers/Documents/selectors';
import { layouts } from 'containers/Layouts/selectors';
import { projectType } from 'containers/Project/selectors';
import { relationsByRegularLayoutId } from 'containers/Relations/selectors';

export const groupLayoutSelector = createStructuredSelector({
  documents,
  layouts,
  dragHotspotGroupLayoutId,
  dragHotspotPosition,
  moveableLayoutId,
  projectType,
  relationsByRegularLayoutId,
});
